import script from "./LandingHome.vue?vue&type=script&lang=ts&setup=true"
export * from "./LandingHome.vue?vue&type=script&lang=ts&setup=true"

import "./LandingHome.vue?vue&type=style&index=0&id=4de05650&scoped=true&lang=scss"
import "./LandingHome.vue?vue&type=style&index=1&id=4de05650&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4de05650"]])

export default __exports__